import { configureStore } from "@reduxjs/toolkit";
// import connectApi from "./reducers/reducer";
import reducerWeb from "./reducers/reducerWeb";
import reducerUser from "./reducers/reducerUser";
import reducerVote from "./reducers/reducerVote";

export const store = configureStore({
  reducer: {
    // connectApi,
    reducerWeb,
    reducerUser,
    reducerVote,
  },
});
